module.exports = __webpack_public_path__ + "static/media/login-footer.8ddf1323.png";